import React, { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { compareAsc, format, addMonths } from "date-fns";
import moment from "moment";
import jwt_decode from "jwt-decode";
import Skills from "./Skills/Skills";
import {
  getPermissions,
  set_user_info,
} from "../../Redux/Actions/login_actions";
function ProfileCom() {
  const dispatch = useDispatch();
  const get_oermission_data = useSelector((state) => state);
  const user_info = get_oermission_data.login_Permission.user_data;
  const getjoining_date = get_oermission_data?.login_Permission?.user_data
    ?.joining_date
    ? new Date(get_oermission_data?.login_Permission?.user_data?.joining_date)
    : "";

  const user_img = user_info?.img
    ? user_info?.img
    : user_info?.gender == 1
    ? "m_user.png"
    : "f_user.png";

  const FNL_Reporting = user_info?.FNL_Reporting
    ? user_info?.FNL_Reporting
    : "";
  const system_role = user_info?.system_role ? user_info?.system_role : "";
  const RMGF = user_info?.RMGF ? user_info?.RMGF : "";
  const RMGM = user_info?.RMGM ? user_info?.RMGM : "";
  const RMGL = user_info?.RMGL ? user_info?.RMGL : "";
  const userFname = user_info?.fname ? user_info?.fname : "";
  const userMname = user_info?.mname ? user_info?.mname : "";
  const userLname = user_info?.lname ? user_info?.lname : "";
  const salutation = user_info?.salutation ? user_info?.salutation : "";
  const userCompany = user_info?.comp_id ? user_info?.comp_id : "";
  const user_status = userCompany == 1 ? true : userCompany == 2 ? true : "";

  const [gender, setGender] = useState("");
  const [dateofbirth, setDateofbirth] = useState("");
  const [dateofjoining, setDateofjoining] = useState("");
  const [dateofmarr, setDateofmarr] = useState("");
  const [marriage, setMarriage] = useState("");
  const [bloodgroup, setBloodgroup] = useState("");
  const [nationality, setNationality] = useState("");
  const [adhaarname, setAdhaarname] = useState("");
  const [adhaarnumber, setAdhaarnumber] = useState("");
  const [pancardnumber, setPancardnumber] = useState("");
  const [empstatus, setEmpstatus] = useState();
  const [contactnumber, setContactnumber] = useState(user_info?.contact);
  const [email, setEmail] = useState();
  const [emailpersonal, setEmailpersonal] = useState();
  const [empcode, setEmpcode] = useState("");
  const [userrole, setUserrole] = useState("");
  const [userdept, setUserdept] = useState(user_info.dept_name);
  const [role, setRole] = useState();
  const [division, setDivision] = useState("");
  const [company, setCompany] = useState("");
  const [probation_period, setProbation_period] = useState("");
  const [confirmationdate, setConfirmationdate] = useState("");
  const [pincode, setPincode] = useState("");
  const [department, setDepartment] = useState(user_info.role);
  const [fathersName, setFathersName] = useState("");
  const [emr_name, setEmr_name] = useState(user_info?.emergencycontactperson);
  const [emr_relation, setEmr_relation] = useState(user_info?.personrelation);
  const [emr_number, setEmr_number] = useState(user_info?.emergencyphonenumber);
  const [countrylist, setCountrylist] = useState([]);
  const [country, setCountry] = useState(user_info?.country);
  const [state, setState] = useState(user_info?.state);
  const [statelist, setStatelist] = useState([]);
  const [update_status, setUpdate_status] = useState(true);
  const [address, setAddress] = useState("");

  let SERVER_URL = process.env.REACT_APP_API_URL;
  let BASE_URL = process.env.REACT_APP_APP_URL;
  let token = JSON.parse(localStorage.getItem("key"));
  const [userId, setUserId] = useState(localStorage.getItem("userId"));
  const [picture, setPicture] = useState(null);
  const HandleProfileImg = async (e) => {
    if (e.target.files[0]) {
      setPicture(e.target.files[0]);
      const formdata = new FormData();
      formdata.append("user_id", userId);
      formdata.append("userImage", e.target.files[0]);
      upload_User_Image(formdata);
    }
  };

  useEffect(() => {
    setEmr_name(user_info?.emergencycontactperson);
    setEmr_relation(user_info?.personrelation);
    setEmr_number(user_info?.emergencyphonenumber);
    setContactnumber(user_info?.contact);
    setFathersName(user_info?.guardian_name);
    setEmailpersonal(user_info?.personal_email);

    setAddress(user_info?.address);
    setPancardnumber(user_info?.pan_no);
    setMarriage(user_info?.marrige_status);
    setGender(user_info?.gender);
    setDateofmarr(moment(user_info?.wedding_day).format("yyyy-MM-DD"));
    setDateofbirth(moment(user_info?.birthday).format("yyyy-MM-DD"));
    // setDateofjoining(moment(response.joining_date).format('yyyy-MM-DD'))

    // setConfirmationdate

    setBloodgroup(user_info?.blood_group);
    setPincode(user_info?.zipcode);
  }, [user_info?.emergencycontactperson]);

  useEffect(() => {
    if (getjoining_date != "") {
      const end = addMonths(getjoining_date, 6);
      const confDate = format(end, "dd, MMM yyyy");
      setConfirmationdate(confDate);
    }
  }, [getjoining_date]);

  useEffect(() => {
    setAdhaarnumber(user_info?.uid_no ? user_info?.uid_no : "");
    getCountryList();
    getStateByCID(user_info.country);
  }, [user_info.country]);
  const getCountryList = () => {
    const response = fetch(SERVER_URL + `api/common/country_list`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          //  setComplist(data.result)
          setCountrylist(data.result);
        }
      });
  };
  const getStateByCID = async (id) => {
    const response = await fetch(
      SERVER_URL + `api/common/state?countryId=${id}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: `bearer ${token.value}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          setStatelist(data.result);
        }
      });
  };
  function upload_User_Image(formdata) {
    const response = fetch(SERVER_URL + `api/employee/user-image-update`, {
      method: "post",
      headers: {
        Accept: "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: formdata,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          dispatch(set_user_info());
        }
      });
  }
  const handleUpdateStatus = () => {
    setUpdate_status(!update_status);
  };
  const [updateMsg, setUpdateMsg] = useState("");
  const handleUpdateProfile = () => {



    
    const response = fetch(SERVER_URL + `api/employee/userupdate`, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        id: userId,
        emgname: emr_name,
        emgcontact: emr_number,
        emgrelation: emr_relation,
        pannumber: pancardnumber,
        adharnumber: adhaarnumber,
        nationality: nationality,
        marriagestatus: marriage,
        contact: contactnumber,
        fathersName: fathersName,
        address: address,
        gender: gender,
        dateofmarr: dateofmarr,
        pincode: pincode,
        bloodgroup: bloodgroup,
        dateofbirth: dateofbirth,
        emailpersonal: emailpersonal,
        country: country,
        state: state,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          setUpdateMsg(data.msg);
          setUpdate_status(true);
          dispatch(set_user_info(userId));
          setTimeout(() => {
            setUpdateMsg("");
          }, 1000);
        }
      });
  };

  const handleCountry = (e) => {
    setCountry(e.target.value);
    getStateByCID(e.target.value);
  };
  const weddingdateInputRef = useRef(null);
  const handleClick = () => {
    if (weddingdateInputRef.current) {
      weddingdateInputRef.current.showPicker?.(); // Only works in modern browsers (Chrome, Edge)
      weddingdateInputRef.current.focus(); // Fallback to focus
    }
  };

  const dateOfBirthInputRef = useRef(null);
  const handleClickDateOfBirth = () => {
    if (dateOfBirthInputRef.current) {
      dateOfBirthInputRef.current.showPicker?.(); // Only works in modern browsers (Chrome, Edge)
      dateOfBirthInputRef.current.focus(); // Fallback to focus
    }
  };

  return (
    <div className="container-fluid">
      <div className="dash_ttl">Profile</div>
      <div className="crumbs">
        <ul id="breadcrumbs" className="breadcrumb">
          <li>
            <a href="#">Dashboard </a>
          </li>
          <li className="current">
            <span>/</span>Profile
          </li>
        </ul>
      </div>
      <div className="profile_detail_wrp">
        <div className="row">
          <div className="col-md-3">
            <div className="profile_detail">
              <div className="profile_img_wrp">
                <div className="pro_img profile_upload_wrp">
                  <img
                    src={`${SERVER_URL + "userimages/" + user_img}`}
                    alt=""
                  />
                  <div className="buttonwrap">
                    <label className="button_upload" htmlFor="upload">
                      <i className="fa fa-camera"></i>
                    </label>
                    <input
                      id="upload"
                      type="file"
                      onChange={HandleProfileImg}
                    />
                  </div>
                </div>
                <div className="pro_detail">
                  <div className="pro_detail">
                    <div className="pro_title">
                      {" "}
                      {userFname + " " + userMname + " " + userLname}
                    </div>
                    <div className="pro_sub_head">
                      {" "}
                      {user_info?.role_name ? user_info.role_name : ""}
                    </div>
                    <div className="pro_sub_head">
                      <i className="icon icon-apartment"></i>
                      {user_info?.dept_name ? user_info.dept_name : ""}
                    </div>
                  </div>
                </div>
              </div>
              <div className="pro_wrp">
                <div className="pro_blk">
                  <div className="pro_heading">Phone Number</div>
                  <div className="pro_sub_head">
                    <i className="icon icon-telephone2 mr08"></i>
                    {user_info?.contact ? user_info?.contact : ""}
                  </div>
                </div>
                <div className="pro_blk">
                  <div className="pro_heading">Email</div>
                  <div className="pro_sub_head">
                    <i className="icon icon-envelope mr08"></i>
                    {user_info?.email ? user_info?.email : ""}
                  </div>
                </div>
                <div className="pro_blk">
                  <div className="pro_heading">Date of Birth</div>
                  <div className="pro_sub_head">
                    <i className="icon icon-cake mr08"></i>
                    {/* {user_info?.birth ? moment(user_info?.birth).format("DD, MMM YYYY") : ""} */}

                    {user_info?.birth && moment(user_info.birth).isValid()
                      ? moment(user_info.birth).format("DD, MMM YYYY")
                      : "N/A"}
                  </div>
                </div>
                <div
                  className="pro_blk"
                  style={{ display: user_status == true ? "block" : "none" }}
                >
                  <div className="pro_heading">Date of Joining</div>
                  <div className="pro_sub_head">
                    <i className="icon icon-calendar-full mr08"></i>
                    {user_info?.dateOfJoining
                      ? moment(user_info?.dateOfJoining).format("DD, MMM YYYY")
                      : ""}
                  </div>
                </div>
                <div className="pro_blk">
                  <div className="pro_heading">System Role</div>
                  <div className="pro_sub_head">
                    {system_role ? system_role : ""}
                  </div>
                </div>

                <div className="pro_blk">
                  <div className="pro_heading">Reporting Manager</div>
                  <div className="pro_sub_head">
                    {RMGF ? RMGF : ""} {RMGM ? RMGM : ""} {RMGL ? RMGL : ""}
                  </div>
                </div>
                <div className="pro_blk">
                  <div className="pro_heading">Final Reporting Manager</div>
                  <div className="pro_sub_head">
                    {FNL_Reporting ? FNL_Reporting : ""}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-9 relative">
            <div
              className="nav"
              id="profiletab"
              role="tablist"
              aria-orientation="vertical"
            >
              <a
                className="nav-link active"
                id="personal-tab"
                data-bs-toggle="tab"
                href="#personal"
                data-bs-target="#personal"
              >
                Personal Profile
              </a>

              <a
                className="nav-link"
                id="contact-tab"
                data-bs-toggle="tab"
                href="#contact"
                data-bs-target="#contact"
              >
                Contact Details
              </a>

              <a
                className="nav-link"
                id="official-tab"
                data-bs-toggle="tab"
                href="#official"
                data-bs-target="#official"
              >
                Official
              </a>
              {/* <a
                className="nav-link"
                id="skills-tab"
                data-bs-toggle="tab"
                href="#skills"
                data-bs-target="#skills"
              >
                Skills
              </a> */}
            </div>
            <div className="tab-content" id="profiletabContent">
              <div
                className="tab-pane fade active show"
                id="personal"
                role="tabpanel"
                aria-labelledby="personal-tab"
              >
                <div
                  style={{ display: update_status == true ? "block" : "none" }}
                >
                  <div className="row mb30">
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Salutation</div>
                        <div className="form-input fw-500">
                          {salutation
                            ? salutation == 1
                              ? "Mr"
                              : salutation == 2
                              ? "Ms"
                              : salutation == 3
                              ? "Mrs"
                              : ""
                            : ""}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">FIRST NAME</div>
                        <div className="form-input fw-500">
                          {userFname ? userFname : ""}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Middle Name</div>
                        <div className="form-input fw-500">
                          {userMname ? userMname : ""}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Last Name</div>
                        <div className="form-input fw-500">
                          {userLname ? userLname : ""}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Personal Email</div>
                        <div className="form-input fw-500">
                          {user_info.personal_email
                            ? user_info.personal_email
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Father/Husband Name</div>
                        <div className="form-input fw-500">
                          {user_info.guardian_name
                            ? user_info.guardian_name
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-md-4"
                      style={{
                        display: user_status == true ? "block" : "none",
                      }}
                    >
                      <div className="form-blk mb20">
                        <div className="form-label">Gender</div>
                        <div className="form-input fw-500">
                          {user_info.gender
                            ? user_info.gender == 1
                              ? "Male"
                              : "Female"
                            : user_info.gender == null
                            ? "N/A"
                            : ""}
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Date Of Birth</div>
                      <div className="form-input fw-500">
                        {moment(dateofbirth ? dateofbirth : "").format(
                          "DD MMM, yyyy"
                        )}
                      </div>
                    </div>
                  </div> */}
                    <div
                      className="col-md-4"
                      style={{
                        display: user_status == true ? "block" : "none",
                      }}
                    >
                      <div className="form-blk mb20">
                        <div className="form-label">Marital Status</div>
                        <div className="form-input fw-500">                         
                          {marriage
                            ? marriage == 1
                              ? "Married"
                              : marriage == 2
                              ? "Unmarried"
                              : marriage == 3
                              ? "Other"
                              : ""
                            : "N/A"}
                        </div>
                      </div>
                    </div>

                    {/* <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Nationality</div>
                        <div className="form-input fw-500">
                          {user_info.nationality_type ? user_info.nationality_type : "N/A"}
                        </div>
                      </div>
                    </div> */}

                    <div
                      className="col-md-4"
                      style={{
                        display: user_status == true ? "block" : "none",
                      }}
                    >
                      <div className="form-blk mb20">
                        <div className="form-label">Date Of Birth</div>
                        <div className="form-input fw-500">
                          {user_info.birthday
                            ? moment(user_info.birthday).format(
                                "DD, MMM YYYY"
                              ) == "Invalid date"
                              ? "N/A"
                              : moment(user_info.birthday).format(
                                  "DD, MMM YYYY"
                                )
                            : ""}
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-md-4"
                      style={{
                        display: user_status == true ? "block" : "none",
                      }}
                    >
                      <div className="form-blk mb20">
                        <div className="form-label">Wedding anniversary</div>
                        <div className="form-input fw-500">
                          {user_info.wedding_day
                            ? moment(user_info.wedding_day).format(
                                "DD, MMM YYYY"
                              ) == "Invalid date"
                              ? "N/A"
                              : moment(user_info.wedding_day).format(
                                  "DD, MMM YYYY"
                                )
                            : ""}
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-md-4"
                      style={{
                        display: user_status == true ? "block" : "none",
                      }}
                    >
                      <div className="form-blk mb20">
                        <div className="form-label">Blood group</div>
                        <div className="form-input fw-500">
                          {user_info.blood_group
                            ? user_info.blood_group
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">
                          {user_status == true ? "Aadhaar Card Number" : "SSN"}
                        </div>
                        <div className="form-input fw-500">
                          {user_info.uid_no ? user_info.uid_no : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Contact Number</div>
                        <div className="form-input fw-500">
                          {user_info?.contact ? user_info?.contact : "N/A"}
                        </div>
                      </div>
                    </div>

                    {/* <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Aadhaar Card Name</div>
                        <div className="form-input fw-500">
                          {user_info.uid_name ? user_info.uid_name : "N/A"}
                        </div>
                      </div>
                    </div> */}
                    <div
                      className="col-md-4"
                      style={{
                        display: user_status == true ? "block" : "none",
                      }}
                    >
                      <div className="form-blk mb20">
                        <div className="form-label">Pan Card Number</div>
                        <div className="form-input fw-500">
                          {user_info.pan_no ? user_info.pan_no : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Status</div>
                        <div className="form-input fw-500">
                          {user_info.status
                            ? user_info.status == 1
                              ? "Active"
                              : "Inactive"
                            : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{ display: update_status == false ? "block" : "none" }}
                >
                  <div className="row mb30">
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Salutation </div>
                        <div className="form-input fw-500">
                          <input
                            type="text"
                            disabled
                            className="form-control"
                            value={
                              salutation
                                ? salutation == 1
                                  ? "Mr"
                                  : salutation == 2
                                  ? "Ms"
                                  : salutation == 3
                                  ? "Mrs"
                                  : ""
                                : ""
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">FIRST NAME</div>
                        <div className="form-input fw-500">
                          <input
                            type="text"
                            disabled
                            className="form-control"
                            value={userFname ? userFname : ""}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Middle Name</div>
                        <div className="form-input fw-500">
                          <input
                            type="text"
                            disabled
                            className="form-control"
                            value={userMname ? userMname : ""}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Last Name</div>
                        <div className="form-input fw-500">
                          <input
                            type="text"
                            disabled
                            className="form-control"
                            value={userLname ? userLname : ""}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Personal Email</div>
                        <div className="form-input fw-500">
                          <input
                            disabled
                            value={emailpersonal}
                            onChange={(e) => setEmailpersonal(e.target.value)}
                            type="text"
                            placeholder="Enter personal email"
                            className="form-control form-control1"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Father/Husband Name</div>
                        <div className="form-input fw-500">
                          <input
                            value={fathersName}
                            onChange={(e) => setFathersName(e.target.value)}
                            type="text"
                            placeholder="Enter Father/Husband Name"
                            className="form-control form-control1"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-md-4"
                      style={{
                        display: user_status == true ? "block" : "none",
                      }}
                    >
                      <div className="form-blk mb20">
                        <div className="form-label">Gender</div>
                        <div className="form-input fw-500">
                          <select
                            className="form-select"
                            value={gender}
                            onChange={(e) => setGender(e.target.value)}
                          >
                            <option value="">Select Gender</option>
                            <option value="1">Male</option>
                            <option value="2">Female</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-md-4"
                      style={{
                        display: user_status == true ? "block" : "none",
                      }}
                    >
                      <div className="form-blk mb20">
                        <div className="form-label">Marital Status</div>
                        <div className="form-input fw-500">
                          <select
                            value={marriage}
                            onChange={(e) => setMarriage(e.target.value)}
                            className="form-select"
                          >
                            <option value="">Select Marital Status</option>
                            <option value="1">Married</option>
                            <option value="2">Unmarried</option>
                            <option value="3">Other</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    {/* <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Nationality</div>
                        <div className="form-input fw-500">
                          <input type="text" disabled className="form-control" value={user_info.nationality_type ? user_info.nationality_type : "N/A"} />

                        </div>
                      </div>
                    </div> */}
                    <div
                      className="col-md-4"
                      style={{
                        display: user_status == true ? "block" : "none",
                      }}
                    >
                      <div className="form-blk mb20">
                        <div className="form-label">Date Of Birth</div>
                        <div
                          className="form-input fw-500"
                          onClick={handleClickDateOfBirth}
                          style={{ cursor: "pointer" }}
                        >
                          <input
                            type="date"
                            ref={dateOfBirthInputRef}
                            value={dateofbirth}
                            onChange={(e) => setDateofbirth(e.target.value)}
                            className="form-control"
                            placeholder="Select Date of birth"
                          />
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-md-4" style={{ display: user_status == true ? 'block' : 'none' }}>
                      <div className="form-blk mb20">
                        <div className="form-label">Wedding anniversary</div>
                        <div className="form-input fw-500">
                          <input type="date" value={dateofmarr} onChange={e => setDateofmarr(e.target.value)} className="form-control" placeholder="Select Date of Wedding anniversary" />
                        </div>
                      </div>
                    </div> */}

                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Wedding anniversary</div>
                        <div
                          className="form-input fw-500"
                          onClick={handleClick}
                          style={{ cursor: "pointer" }}
                        >
                          <input
                            type="date"
                            ref={weddingdateInputRef}
                            value={dateofmarr}
                            onChange={(e) => setDateofmarr(e.target.value)}
                            className="form-control"
                            placeholder="Select Date of Wedding anniversary"
                          />
                        </div>
                      </div>
                    </div>

                    <div
                      className="col-md-4"
                      style={{
                        display: user_status == true ? "block" : "none",
                      }}
                    >
                      <div className="form-blk mb20">
                        <div className="form-label">Blood group</div>
                        <div className="form-input fw-500">
                          <input
                            type="text"
                            value={bloodgroup}
                            onChange={(e) => setBloodgroup(e.target.value)}
                            placeholder="Enter Blood group"
                            className="form-control form-control1"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">
                          {user_status == true ? "Aadhaar Card Number" : "SSN"}
                        </div>
                        <div className="form-input fw-500">
                          <input
                            type="text"
                            value={
                              adhaarnumber ? adhaarnumber : user_info?.uid_no
                            }
                            onChange={(e) => setAdhaarnumber(e.target.value)}
                            placeholder={
                              user_status == true
                                ? "Enter Aadhaar Card Number"
                                : "Enter SSN"
                            }
                            className="form-control form-control1"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Contact Number</div>
                        <div className="form-input fw-500">
                          <input
                            type="text"
                            value={
                              contactnumber ? contactnumber : user_info?.contact
                            }
                            onChange={(e) => setContactnumber(e.target.value)}
                            placeholder="Enter contact number"
                            className="form-control form-control1"
                          />
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-md-4" style={{ display: user_status == true ? 'block' : 'none' }}>
                      <div className="form-blk mb20">
                        <div className="form-label">Aadhaar Card Name</div>
                        <div className="form-input fw-500">
                          <input type="text" placeholder="Enter Aadhaar Card Name" className="form-control form-control1" />
                        </div>
                      </div>
                    </div> */}
                    <div
                      className="col-md-4"
                      style={{
                        display: user_status == true ? "block" : "none",
                      }}
                    >
                      <div className="form-blk mb20">
                        <div className="form-label">Pan Card Number</div>
                        <div className="form-input fw-500">
                          <input
                            value={pancardnumber}
                            onChange={(e) => setPancardnumber(e.target.value)}
                            type="text"
                            placeholder="Enter Pan Card Number"
                            className="form-control form-control1"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Status</div>
                        <div className="form-input fw-500">
                          <input
                            type="text"
                            disabled
                            className="form-control"
                            value={
                              user_info.status
                                ? user_info.status == 1
                                  ? "Active"
                                  : "Inactive"
                                : ""
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="tab-pane fade"
                id="contact"
                role="tabpanel"
                aria-labelledby="contact-tab"
              >
                <div className="tab_sub_ttl">Current Address</div>
                <div
                  className="address_wrp"
                  style={{ display: update_status == true ? "block" : "none" }}
                >
                  <div className="row mb10">
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Address</div>
                        <div className="form-input">
                          {user_info?.address ? user_info?.address : "N/A"}
                        </div>
                      </div>
                    </div>

                    {/* <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">City</div>
                        <div className="form-input">{user_info.city ? user_info.city : 'N/A'}</div>
                      </div>
                    </div> */}
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Country</div>
                        <div className="form-input">
                          <select
                            disabled
                            value={country ? country : user_info.country}
                            onChange={(e) => setCountry(e.target.value)}
                            className="form-select"
                          >
                            <option value="">Select Country</option>
                            {countrylist.map((item, ind) => {
                              return (
                                <option key={ind} value={item.id}>
                                  {item.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">State</div>
                        <div className="form-input">
                          {" "}
                          <select
                            disabled
                            value={state ? state : user_info.state}
                            onChange={(e) => setState(e.target.value)}
                            className="form-select"
                          >
                            <option value="">Select State</option>
                            {statelist.map((item, ind) => {
                              return (
                                <option key={ind} value={item.id}>
                                  {item.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-md-4"
                      style={{
                        display: user_status == true ? "block" : "none",
                      }}
                    >
                      <div className="form-blk mb20">
                        <div className="form-label">Pin Code</div>
                        <div className="form-input">
                          {user_info.zipcode ? user_info.zipcode : "N/A"}
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-md-4">
						<div className="form-blk mb20">
						  <div className="form-label">Mobile #</div>
						  <div className="form-input">
							{contactnumber ? contactnumber : "N/A"}
						  </div>
						</div>
					  </div> */}
                    {/* <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Email Personal</div>
                        <div className="form-input">
                          {user_info.personal_email ? user_info.personal_email : "N/A"}
                        </div>
                      </div>
                    </div> */}
                  </div>
                  <div className="tab_sub_ttl">Emergency Contact</div>
                  <div className="row mb30">
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Name</div>
                        <div className="form-input">
                          {user_info.emergencycontactperson
                            ? user_info.emergencycontactperson
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Relationship</div>
                        <div className="form-input">
                          {" "}
                          {user_info.personrelation
                            ? user_info.personrelation
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Mobile #</div>
                        <div className="form-input">
                          {" "}
                          {user_info.emergencyphonenumber
                            ? user_info.emergencyphonenumber
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="address_wrp"
                  style={{ display: update_status == false ? "block" : "none" }}
                >
                  <div className="row mb10">
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Address</div>
                        <div className="form-input">
                          <input
                            type="text"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            placeholder="Enter Address"
                            className="form-control form-control1"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Country</div>
                        <div className="form-input">
                          <select
                            value={country ? country : user_info.country}
                            onChange={handleCountry}
                            className="form-select"
                          >
                            <option value="">Select Country</option>
                            {countrylist.map((item, ind) => {
                              return (
                                <option key={ind} value={item.id}>
                                  {item.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">State</div>
                        <div className="form-input">
                          <select
                            value={state ? state : user_info.state}
                            onChange={(e) => setState(e.target.value)}
                            className="form-select"
                          >
                            <option value="">Select State</option>
                            {statelist.map((item, ind) => {
                              return (
                                <option key={ind} value={item.id}>
                                  {item.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-md-4"
                      style={{
                        display: user_status == true ? "block" : "none",
                      }}
                    >
                      <div className="form-blk mb20">
                        <div className="form-label">Pin Code</div>
                        <div className="form-input">
                          <input
                            type="text"
                            placeholder="Enter Pin Code"
                            value={pincode}
                            onChange={(e) => setPincode(e.target.value)}
                            className="form-control form-control1"
                          />
                        </div>
                      </div>
                    </div>

                    {/* <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Email Personal</div>
                        <div className="form-input">
                          <input type="text" placeholder="Enter Pin Code" value={user_info.personal_email ? user_info.personal_email : "N/A"} className="form-control form-control1" />

                        </div>
                      </div>
                    </div> */}
                  </div>
                  <div className="tab_sub_ttl">Emergency Contact</div>
                  <div className="row mb30">
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Name</div>
                        <div className="form-input">
                          <input
                            type="text"
                            placeholder="Enter Name"
                            value={
                              emr_name
                                ? emr_name
                                : user_info?.emergencycontactperson
                            }
                            onChange={(e) => setEmr_name(e.target.value)}
                            className="form-control form-control1"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Relationship</div>
                        <div className="form-input">
                          <input
                            type="text"
                            placeholder="Enter Relationship"
                            value={
                              emr_relation
                                ? emr_relation
                                : user_info?.personrelation
                            }
                            onChange={(e) => setEmr_relation(e.target.value)}
                            className="form-control form-control1"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb20">
                        <div className="form-label">Mobile #</div>
                        <div className="form-input">
                          <input
                            type="text"
                            placeholder="Enter Mobile"
                            value={
                              emr_number
                                ? emr_number
                                : user_info?.emergencyphonenumber
                            }
                            onChange={(e) => setEmr_number(e.target.value)}
                            className="form-control form-control1"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="tab-pane fade"
                id="official"
                role="tabpanel"
                aria-labelledby="official-tab"
              >
                <div className="tab_sub_ttl">Organization</div>
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Company</div>
                      <div className="form-input">
                        {user_info.comp_id
                          ? user_info.comp_id == 1
                            ? "Q2A Media Services Pvt Ltd"
                            : user_info.comp_id == 2
                            ? "Q2A Services Pvt Ltd"
                            : user_info.comp_id == 3
                            ? "Bill Smith Group Inc"
                            : ""
                          : ""}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Division</div>
                      <div className="form-input">
                        {user_info?.division ? user_info.division : "N/A"}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Department</div>
                      <div className="form-input">
                        {user_info.department ? user_info.department : "N/A"} (
                        {user_info?.skill ? user_info?.skill : "N/A"})
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tab_sub_ttl">Employee Details</div>
                <div className="row mb25">
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Employee Code</div>
                      <div className="form-input">
                        {user_info.user_code ? user_info.user_code : ""}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Employee Status</div>
                      <div className="form-input">
                        {user_info.user_type
                          ? user_info.user_type
                            ? "Active"
                            : "Inactive"
                          : "N/A"}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Date of joining</div>
                      <div className="form-input">
                        {/* {dateofjoining?dateofjoining.format('MMM-DD-YYYY'):''} */}
                        {user_info.joining_date
                          ? moment(user_info.joining_date).format(
                              "DD, MMM YYYY"
                            )
                          : "N/A"}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">
                        Probation Period (Months)
                      </div>
                      <div className="form-input">
                        {user_info.probation_period
                          ? user_info.probation_period
                          : "6 Month"}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Confirmation Date</div>
                      <div className="form-input">
                        {confirmationdate ? confirmationdate : ""}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Designation </div>
                      <div className="form-input">
                        {user_info.role_name ? user_info.role_name : "N/A"}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Notice Period (Days) </div>
                      <div className="form-input">
                        {" "}
                        {user_info.noticeperiod
                          ? user_info.noticeperiod + " Days"
                          : "N/A"}{" "}
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className=" text-end">
                  <button className="btn_5">Edit</button>
                </div> */}
              </div>
              <div className=" text-end">
                <div style={{ color: "green" }}>{updateMsg}</div>
                <button
                  style={{
                    display: update_status == true ? "none" : "inline-block",
                  }}
                  className="btn_7 mr05"
                  onClick={handleUpdateProfile}
                >
                  Update
                </button>
                <button onClick={handleUpdateStatus} className="btn_5">
                  {update_status == true ? "Edit" : "Cancel"}
                </button>
              </div>

              {/* <Skills department={userdept} page_action={'view'} department_id={department} /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProfileCom;
